import { useMemo } from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Hook pour obtenir les styles react-select adaptés au thème dark/light
 */
export const useSelectStyles = () => {
  const { theme } = useTheme();
  
  return useMemo(() => ({
    control: (base) => ({
      ...base,
      backgroundColor: theme === 'dark' ? '#374151' : '#fff',
      borderColor: theme === 'dark' ? '#4B5563' : '#D1D5DB',
      color: theme === 'dark' ? '#E5E7EB' : '#111827',
      '&:hover': {
        borderColor: theme === 'dark' ? '#6B7280' : '#9CA3AF',
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: theme === 'dark' ? '#374151' : '#fff',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused 
        ? (theme === 'dark' ? '#4B5563' : '#E5E7EB')
        : (theme === 'dark' ? '#374151' : '#fff'),
      color: theme === 'dark' ? '#E5E7EB' : '#111827',
      '&:active': {
        backgroundColor: theme === 'dark' ? '#6B7280' : '#D1D5DB',
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: theme === 'dark' ? '#E5E7EB' : '#111827',
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: theme === 'dark' ? '#4B5563' : '#E5E7EB',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: theme === 'dark' ? '#E5E7EB' : '#111827',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: theme === 'dark' ? '#E5E7EB' : '#111827',
      '&:hover': {
        backgroundColor: theme === 'dark' ? '#6B7280' : '#D1D5DB',
        color: theme === 'dark' ? '#E5E7EB' : '#111827',
      },
    }),
    input: (base) => ({
      ...base,
      color: theme === 'dark' ? '#E5E7EB' : '#111827',
    }),
    placeholder: (base) => ({
      ...base,
      color: theme === 'dark' ? '#9CA3AF' : '#6B7280',
    }),
  }), [theme]);
};

